<template>
  <div>
    <Header :tab="0" />
    <swiper id="banner" :options="swiperOption" class="swiper-wrap banner-swiper" ref="mySwiper">
      <swiper-slide v-for="(item, index) in homeData.banner" :key="index" >
        <div class="banner-wrap">
          <a :href="item.url" target="_blank">
          <img class="cp" style="width:100%;height:100%;" :src="item.img" alt="" />
        </a>
        </div>
      </swiper-slide>
      <!-- 常见的小圆点 -->
      <div class="swiper-pagination banner-swiper-pagination" v-for="(item, index) in homeData.banner" :key="index" slot="pagination" ></div>
    </swiper>
    <div id="about" class="white-bg common-padding flex fww jcc" style="padding-top:80px;">
      <div class="about-wrap">
        <video style="width:100%;height:100%;" :src="homeData.about.video" controls="controls"></video>
      </div>
      <div class="flex fxdc jcsb about-wrap" style="margin-left:30px;width: 500px">
        <div>
          <div class="tag">我们的故事</div>
          <div class="title">关于七十迈旅行</div>
          <div class="describe">{{homeData.about.text}}</div>
        </div>
        <!-- <a :href="homeData.about.url" target="_blank">
          <div class="button" style="width: 110px">更多关于我们</div>
        </a> -->
      </div>
    </div>
    <div id="roadbook" class="warp-bg common-padding flex fxdc aic">
      <div class="tag">轻松出行</div>
      <div class="title">智能路书</div>
      <div class="describe tac" style="width:560px">{{homeData.roadbook.text}}</div>
      <swiper :options="roadbookSwiperOption" class="roadbook-wrap" ref="mySwiper">
        <swiper-slide v-for="(item, index) in homeData.roadbook.booklist" :key="index" :style="item.window?scaleFun:notscale">
          <div class="roadbook-box" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)">
            <div class="roadbook-hover" v-show="item.window">
                <div class="roadbook-hover-window">
                  <img :src="item.url" alt="">
                  <p class="fw600">微信扫一扫</p>
                </div>
            </div>
            <img class="roadbook-image" :src="item.image" alt="" />
            <div class="roadbook-info"  >
              <div class="flex jcsb">
                <div class="ellipsis fs17 fw500">{{item.name}}</div>
                <div class="red-color fs12">¥<span class="fs17 fw500">{{item.price}}</span></div>
              </div>
              <div class="gray-color fs14 ellipsis">{{item.subname}}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div id="customize" class="flex fww jcc aic customize-wrap">
      <div style="width: 360px">
        <div class="tag white-color" style="border: 1px solid #fff;">专属旅行</div>
        <div class="title white-color">定制旅行</div>
        <div class="describe white-color">{{homeData.customize.text}}</div>
      </div>
      <div class="customize-box">
        <div class="black-color fs18 tac fw600" style="margin-bottom:30px;">免费定制行程</div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color fw600">目的地</div>
          <div class="customize-input-wrap">
            <input placeholder='请填写目的地' type="text" v-model="place">
          </div>
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color fw600">手机号</div>
          <div class="customize-input-wrap">
            <input placeholder='请填写手机号' type="number" v-model="phoneNumber">
          </div>
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color fw600">验证码</div>
          <div class="flex jcsb aic customize-input-wrap">
            <input style="width:120px" placeholder='请填写验证码' type="number" v-model="authCode">
            <div class="main-color fs12 cp" @click="sendLoginAuthCode">{{authCodeCountDown > 0 ? `${authCodeCountDown}s` : '获取验证码'}}</div>
          </div>
        </div>
        <div class="button cp" style="margin-top:30px" @click="customizeSubmit">立即定制</div>
      </div>
    </div>
    <div id="grouptour" class="white-bg common-padding">
      <div style="width:900px;margin:auto">
        <div class="tag">自驾小团</div>
        <div class="flex aic">
          <div class="title">跟团自驾</div>
          <img style="width:30px;margin-left:8px" src="https://qishimai-1257428522.file.myqcloud.com/website/new/grouptour_icon.png" />
        </div>
        <div class="describe">{{homeData.grouptour.text}}</div>
        <div class="flex grouptour-city">
          <div class="cp" :class="index === groupCityIndex ? 'fs13 grouptour-city-item fw600' :'fs13 grouptour-city-item'" :style="index === groupCityIndex ? 'color: #0BA09A' : 'color: #333333'" v-for="(item, index) in homeData.grouptour.citys" :key="index" @click="() => groupCityIndex = index">{{item.name}}</div>
        </div>
        <div class="flex fww">
          <div class="grouptour-box" v-for="(item, index) in homeData.grouptour.citys[groupCityIndex].routelist" :key="index">
          <a :href="item.url" target="_blank">
            <img class="grouptour-box-img" :src="item.image"></a>
            <div class="fs13 fw500 black-color" style="padding:0 10px;">
              <div style="height:30px">{{item.name}}</div>
              <div class="flex jcsb aic" style="padding:10px 0;">
                <div class="red-color fw500">¥<span class="fs16">{{item.price}}</span>/起</div>
                <div class="main-color cp" @click="goBottom">咨询客服</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="evaluate" class="warp-bg common-padding flex fxdc aic">
      <div class="tag">真实体验</div>
      <div class="title">用户评价</div>
      <div class="describe tac" style="width:500px">{{homeData.evaluate.text}}</div>
      <swiper :options="evaluateSwiperOption" class="evaluate-wrap" ref="mySwiper">
        <swiper-slide v-for="(item, index) in homeData.evaluate.commentlist" :key="index">
          <div class="evaluate-box">
            <div class="flex aic" style="margin-bottom:10px;">
              <img class="evaluate-avatar" :src="item.useravatar" alt="" />
              <div class="fs13 fw500">{{item.username}}</div>
            </div>
            <div class="flex aic main-color fs12" style="margin-bottom:4px;">
              <img style="width:10px;margin-right:4px" src="https://qishimai-1257428522.file.myqcloud.com/website/new/comment_time.png" alt="" />
              <div>{{item.date}}·出行</div>
            </div>
            <div class="gray-color fs12 ellipsis2" style="margin-bottom:14px;">{{item.content}}</div>
            <img class="evaluate-image cp" v-for="(item, index) in item.images" :key="index" :src="item.minImg" @click="imgOnPreviewUrl = item.bigImg" />
          </div>
        </swiper-slide>
        <!-- 常见的小圆点 -->
        <div class="swiper-pagination evaluate-swiper-pagination" v-for="(item, index) in homeData.evaluate.commentlist" :key="index" slot="pagination"></div>
      </swiper>
    </div>
    <div id="travelstory" class="white-bg common-padding">
      <div style="width:900px;margin:auto">
        <div class="tag">景点讲解</div>
        <div class="flex aic">
          <div class="title">旅行故事</div>
          <img style="width:30px;margin-left:8px" src="https://qishimai-1257428522.file.myqcloud.com/website/new/travelstory_icon.png" />
        </div>
        <div class="describe">{{homeData.travelstory.text}}</div>
        <div class="flex fww">
          <div class="travelstory-box" v-for="(item, index) in homeData.travelstory.storylist" :key="index">
            <img class="travelstory-box-img" :src="item.image">
            <div class="flex jcsb aic" style="margin:4px 0 8px 0">
              <div class="flex aic">
                <div class="travelstory-tag">真人讲解</div>
                <div class="fs12 gray-color">主播：{{item.author}}</div>
              </div>
              <div class="flex aic travelstory-play cp" @click="audioPlay(index)">
                <img v-if="index === audioOnPlayIndex && isPlay" src="https://qishimai-1257428522.cos.ap-chongqing.myqcloud.com/website/static/pause_icon.png" style="width:8px;height:10px;margin-right:2px">
                <img v-else src="https://qishimai-1257428522.cos.ap-chongqing.myqcloud.com/website/static/play_icon.png" style="width:8px;height:10px;margin-right:2px">
                <div>{{index === audioOnPlayIndex && isPlay ? '暂停' : '播放'}}</div>
                <audio :id="`audio${index}`" v-if="index === audioOnPlayIndex">
                  <source :src="item.audio" type="audio/mpeg">
                </audio>
              </div>
            </div>
            <div class="fs16 fw500 ellipsis black-color">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="imgOnPreviewUrl" class='modal-mask' @click="imgOnPreviewUrl = undefined">
      <div class='image-preview-box'>
        <!-- <img class='image-preview-box-close' style="height: 20px;width:20px;padding: 10px;" src="../assets/close_icon.png" @click="imgOnPreviewUrl = undefined"> -->
        <img :src="imgOnPreviewUrl">
      </div>
    </div>
    <div v-if="showSuccessModal" class='modal-mask'>
      <div class='modal-box'>
        <img src="https://qishimai-1257428522.file.myqcloud.com/website/new/customerservice_avatar.png" class="modal-avatar" />
        <div class='modal-title' style='margin-top:50px;'>提交成功</div>
        <div class='modal-content' style='margin-top:6px;'>我们已收到您的需求</div>
        <div class='modal-content'>旅行顾问将在<span style="color: #0BA09A;">24小时之内联系您</span></div>
        <div class='modal-content' style='margin-bottom:16px;'>请保持电话畅通</div>
        <div class='modal-btn cp' @click="showSuccessModal = false">好的</div>
      </div>
    </div>
    <div v-if="showToast" class="toast">
      <div>{{toastContent}}</div>
    </div>
    <Footer />
    <FloatingWindow />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import FloatingWindow from '@/components/FloatingWindow.vue';
import { get, post } from '@/utils/config.http';
import { api } from '@/utils/constVar';
import homeData from '@/utils/staticData/homeData';

export default {
  name: 'Home',
  components: { Header, Footer, FloatingWindow },
  data () {
    return {
      homeData,
      groupCityIndex: 0,
      phoneNumber: '',
      authCode: '',
      place: '',
      authCodeCountDown: 0,
      showSuccessModal: false,
      showToast: false,
      toastContent: '',
      imgOnPreviewUrl: undefined,
      audioOnPlayIndex: undefined,
      isPlay: false,
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //循环
        loop: true,
        //设定初始化时slide的索引
        initialSlide: 0,
        //自动播放
        autoplay: 2000,
        autoplayStopOnLast: false,
        paginationClickable: true,

        // autoplay: {
        //   delay: 1000,
        //   stopOnLastSlide: false,
        //   /* 触摸滑动后是否继续轮播 */
        //   disableOnInteraction: false
        // },
        //滑动速度
        speed: 2000,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        on: {
          //滑动之后回调函数
          slideChangeTransitionStart: function() {
            /* realIndex为滚动到当前的slide索引值 */
            that.imgIndex= this.realIndex - 1;
          },
        },
        //分页器设置
        pagination: '.banner-swiper-pagination',
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   type: "bullets"
        // }
      },
      roadbookSwiperOption: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: -10,
        autoplay: 2000,
        autoplayStopOnLast: false,
        paginationClickable: true,
        // slidesOffsetBefore: 100,
      },
      evaluateSwiperOption: {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: ".evaluate-swiper-pagination",
        autoplay: 2000,
        autoplayStopOnLast: false,
        paginationClickable: true,
        // pagination: {
        //   el: ".evaluate-swiper-pagination",
        //   clickable: true,
        //   // type: "bullets"
        // }
      }
    }
  },
  mounted() {
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace('/Mobile');
    } else {
      // alert("pc端");
      this.$router.replace('');
    }
  },
  created() {
    this.homeData.roadbook.booklist.map(item=>{
      item.window = false;
    });
  },
  computed:{
    scaleFun:function () {
      return `transform:scale(1)`
    },
    notscale:function () {
      return `transform:scale(0.85)`
    }
  },
  methods: {
  _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
  },
  sendLoginAuthCode() {
      if (this.authCodeCountDown > 0) {
        return;
      }
      if (!this.place) {
        this.toast("请输入目的地！");
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast("请正确输入手机号！");
          return;
        }
        this.authCodeCountDown = 60;
        this.authCodeCountDownHandle();
        return get(api.getAuthCode, { phoneNumber: this.phoneNumber })
          .then((res) => {
            this.toast("发送成功！");
          })
          .catch((err) => {
            this.toast("发送验证码失败，请稍后重试");
          });
      } else {
        this.toast("请填写手机号！");
      }
    },
    authCodeCountDownHandle() {
      setTimeout(() => {
        this.authCodeCountDown = this.authCodeCountDown - 1;
        this.authCodeCountDownHandle()
      }, 1000)
    },
    customizeSubmit() {
      if ( this.phoneNumber === '' || this.place === '' || this.authCode === '' ) {
        this.toast('请完整填写信息！');
        return;
      }
      return post(api.insertClue, {
        phoneNumber: this.phoneNumber,
        authCode: this.authCode,
        place: this.place,
        source: '官网',
      }).then((res) => {
        this.phoneNumber = '',
        this.authCode = '',
        this.place = '',
        this.authCodeCountDown = 0,
        this.showSuccessModal = true;
      }).catch((err) => {
        this.toast('提交失败！');
      })
    },
    copyToClipboard(s) {
      if (window.clipboardData) {
          window.clipboardData.setData('text', s);
          this.toast('复制成功！');
      } else {
        (function(s) {
          document.oncopy = function(e) {
            e.clipboardData.setData('text', s);
            e.preventDefault();
            document.oncopy = null;
          }
        })(s);
        document.execCommand('Copy');
        this.toast('复制成功！');
      }
    },
    toast(content) {
      this.toastContent = content;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000)
    },
      // 移入
    mouseOver(value) {
      this.homeData.roadbook.booklist[value].window = true;
      this.$set(this.homeData.roadbook.booklist,value,this.homeData.roadbook.booklist[value])
    },
    // 移出
    mouseLeave(value) {
      this.homeData.roadbook.booklist[value].window = false;
      this.$set(this.homeData.roadbook.booklist,value,this.homeData.roadbook.booklist[value])
    },
    audioPlay(index) {
      this.audioOnPlayIndex = index;
      this.$nextTick(() => {
        const audio = document.querySelector(`#audio${index}`);
        if (audio.paused) {
            audio.play();
            this.isPlay = true;
        } else {
          audio.pause();
          this.isPlay = false;
        }

      })
    },
    goBottom() {
      setTimeout(() => {
        document.getElementById('footer').scrollIntoView({block: "center", behavior: "smooth"});
      }, 10)
    }
  },
}
</script>

<style scoped>
.banner-wrap {
  height: 42.7vw;
  max-height: 820px;
  min-height: 512.5px;
}
.roadbook-wrap {
  width: 86vw;
  padding: 40px 6vw 0 7vw;
  /* max-width: 1600px; */
  min-width: 1200px;
}
.roadbook-wrap .swiper-slide{
  transform: scale(0.85);
  transition: all 0.5s;
}
.roadbook-box {
  /* margin: 20px 0; */
  /* padding: 30px 26px; */
  height: 24.8vw;
  /* max-height: 412.8px; */
  min-height: 297.6px;
  background: #FFFFFF;
  box-shadow: 0px 3px 16px rgba(92, 92, 92, 0.16);
  border-radius: 12px;
  overflow: hidden;
  /* transition: all 0.5s; */
}
.roadbook-hover {
  /* 绝对定位 */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.42);
  opacity: 1;
  border-radius: 12px;
  /* 层级 */
  z-index: 1;
}
.roadbook-hover-window {
  width: 69.7%;
  background: #FFFFFF;
  border: 1px solid #707070;
  opacity: 1;
  border-radius: 18px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%)
}
.roadbook-hover-window img{
  display: block;
  width: 75.4%;
  height: auto;
  background: rgba(0, 0, 0, 0);
  opacity: 1;
  margin: 11.25% auto 7.3%;
}
.roadbook-hover-window p{
  width: 100%;
  text-align: center;
  font-size: 1.61vw;
  line-height: 44px;
  color: #283B5E;
  margin: 0 0 8.4%;
  opacity: 1;
}

.roadbook-image {
  width: 100%;
  height: 100%;
}
.roadbook-info {
  position: absolute;
  bottom: 0.6vw;
  left: 0.6vw;
  right: 0.6vw;
  padding: 0.6vw;
  background-color: #fff;
  border-radius: 8px;
}
.about-wrap {
  height: 21.1vw;
  max-height: 405;
  min-height: 253.1px;
  width: 37.5vw;
  max-width: 720px;
  min-width: 450px;
}
.customize-wrap {
  height: 26.5vw;
  max-height: 508px;
  min-height: 317.5px;
  padding: 0 50px;
  background-image: url('https://qishimai-1257428522.file.myqcloud.com/website/static/home_bg1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.customize-box {
  width: 270px;
  margin-left: 220px;
  padding: 28px;
  box-shadow: 0px 3px 14px rgba(165, 165, 165, 0.24);
  border-radius: 11px;
  background-color: #fff;
}
.customize-input-wrap {
  height: 36px;
  width: 190px;
  margin: 6px 0 6px 12px;
  padding: 0 10px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
input {
  height: 36px;
  width: 190px;
}
.grouptour-city {
  margin-top: 10px;
}
.grouptour-city-item {
  padding: 8px 26px 4px 0;
}
.grouptour-box {
  width: 280px;
  margin: 20px 20px 0 0;
  background: #FFFFFF;
  box-shadow: 0px 3px 40px rgba(93, 93, 93, 0.16);
  border-radius: 12px;
  overflow: hidden;
}
.grouptour-box-img {
  width: 280px;
  height: 184px;
}
.evaluate-wrap {
  width: 90vw;
  padding: 20px 0vw 30px;
  /* max-width: 1600px; */
}
.evaluate-box {
  margin: 20px 0;
  padding: 30px 26px;
  background: #FFFFFF;
  box-shadow: 0px 3px 16px rgba(128, 128, 128, 0.16);
  opacity: 1;
  border-radius: 8px;
}
.evaluate-avatar {
  width: 40px;
  height: 40px;
  margin-right: 6px;
  border-radius: 50%;
}
.evaluate-image {
  height: 5.54vw;
  width: 5.54vw;
  margin: 0 0.4vw 0 0.3vw;
  border-radius: 4px;
}
.travelstory-box {
  width: 280px;
  margin: 40px 20px 0 0;
  background: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
}
.travelstory-box-img {
  width: 280px;
  height: 219px;
  object-fit: cover;
}
.travelstory-tag {
  padding: 2px 6px;
  margin-right: 6px;
  border: 1px solid #D7D7D7;
  border-radius: 15px;
  font-size: 12px;
  line-height: 14px;
  color: #6C6C6C;
}
.travelstory-play {
  padding: 2px 6px;
  border: 1px solid #17A09A;
  border-radius: 15px;
  font-size: 12px;
  line-height: 14px;
  color: #17A09A;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue